import React from 'react';

const MarketCapIndicator = ({ marketCap, marketCapChange24h }) => {
  const change = marketCapChange24h || '0.00%';
  const isPositive = change.startsWith('+') || (!change.startsWith('-') && parseFloat(change) > 0);
  const changeColor = change === 'N/A' ? 'text-gray-500' : isPositive ? 'text-green-600' : 'text-red-600';

  return (
    <div className="flex items-center whitespace-nowrap">
      <span className="mr-2 font-medium" title="Total Crypto Market Cap">MCap:</span>
      <span className="font-bold mr-1">
        <a
          href="https://www.tradingview.com/chart/?symbol=CRYPTOCAP%3ATOTAL"
          target="_blank"
          rel="noopener noreferrer"
        >
          ${marketCap || 'N/A'}
        </a>
      </span>
      <span className={`text-xs ${changeColor}`}> {change}</span>
    </div>
  );
};

export default MarketCapIndicator;
